import { CheckCircle, XCircle, ArrowDownToLine } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';

const methodLabel = (m) => ({
  paypal: 'PayPal', zelle: 'Zelle', bank_transfer: 'Bank Transfer',
  stripe: 'Stripe', stripe_connect: 'Stripe Connect',
}[m] || m);

export function WithdrawalsTab({ withdrawals, pendingWithdrawals, handleProcessWithdrawal, handleRejectWithdrawal }) {
  return (
    <div className="space-y-6">
      {pendingWithdrawals.length > 0 && (
        <div className="bg-surface border border-purple-500/30 rounded-xl overflow-hidden">
          <div className="p-4 border-b border-[#262626]">
            <h3 className="font-heading font-bold flex items-center gap-2">
              <ArrowDownToLine className="w-5 h-5 text-purple-500" />
              Pending Withdrawals ({pendingWithdrawals.length})
            </h3>
          </div>
          <div className="divide-y divide-[#262626]">
            {pendingWithdrawals.map((withdrawal) => (
              <div key={withdrawal.id} className="p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <div>
                  <p className="font-bold">
                    {withdrawal.artist_name || withdrawal.agent_name}
                    {withdrawal.agent_id && <Badge className="ml-2 bg-purple-500/10 text-purple-400 border-0">Agent</Badge>}
                  </p>
                  <p className="text-2xl font-mono text-lime">${withdrawal.amount.toFixed(2)}</p>
                  <p className="text-sm text-[#A1A1AA]">via {methodLabel(withdrawal.payout_method)}{withdrawal.payout_details || withdrawal.paypal_email ? `: ${withdrawal.payout_details || withdrawal.paypal_email}` : ''}</p>
                  <p className="text-xs text-[#666]">Requested {new Date(withdrawal.created_at).toLocaleDateString()}</p>
                </div>
                <div className="flex gap-2">
                  <Button onClick={() => handleProcessWithdrawal(withdrawal.id)} size="sm" className="btn-primary" data-testid={`process-withdrawal-${withdrawal.id}`}>
                    <CheckCircle className="w-4 h-4 mr-2" />Mark as Paid
                  </Button>
                  <Button onClick={() => handleRejectWithdrawal(withdrawal.id)} size="sm" variant="outline" className="border-red-500/50 text-red-400 hover:bg-red-500/10" data-testid={`reject-withdrawal-${withdrawal.id}`}>
                    <XCircle className="w-4 h-4 mr-2" />Reject
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="bg-surface border border-[#262626] rounded-xl overflow-hidden">
        <div className="p-4 border-b border-[#262626]"><h3 className="font-heading font-bold">Withdrawal History</h3></div>
        {withdrawals.length === 0 ? (
          <div className="p-8 text-center"><ArrowDownToLine className="w-12 h-12 mx-auto mb-4 text-[#333]" /><p className="text-[#A1A1AA]">No withdrawals yet</p></div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-[#262626]">
                  <th className="text-left p-4 text-sm font-medium text-[#A1A1AA]">Recipient</th>
                  <th className="text-left p-4 text-sm font-medium text-[#A1A1AA]">Amount</th>
                  <th className="text-left p-4 text-sm font-medium text-[#A1A1AA]">Method</th>
                  <th className="text-left p-4 text-sm font-medium text-[#A1A1AA]">Status</th>
                  <th className="text-left p-4 text-sm font-medium text-[#A1A1AA]">Date</th>
                </tr>
              </thead>
              <tbody>
                {withdrawals.map((withdrawal) => (
                  <tr key={withdrawal.id} className="border-b border-[#262626] last:border-0">
                    <td className="p-4">
                      {withdrawal.artist_name || withdrawal.agent_name}
                      {withdrawal.agent_id && <Badge className="ml-2 bg-purple-500/10 text-purple-400 border-0">Agent</Badge>}
                    </td>
                    <td className="p-4 font-mono">${withdrawal.amount.toFixed(2)}</td>
                    <td className="p-4 text-sm">{methodLabel(withdrawal.payout_method)}</td>
                    <td className="p-4">
                      <Badge className={withdrawal.status === 'completed' ? 'bg-green-500/10 text-green-400' : withdrawal.status === 'pending' ? 'bg-yellow-500/10 text-yellow-400' : 'bg-red-500/10 text-red-400'}>{withdrawal.status}</Badge>
                    </td>
                    <td className="p-4 text-sm text-[#A1A1AA]">{new Date(withdrawal.created_at).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
